export default __webpack_public_path__ + "static/media/english-to-swedish-screenshot-05.53ba5b98.png";